import Modal from "components/atom/Modal.tsx";
import Button from "components/atom/button/Button.tsx";
import designerPng from 'assets/images/designer.png'
import {useTranslation} from "react-i18next";

function TrialToPlanModal(props: { isOpen: boolean, onClose: () => void, onAccept: () => void }) {
    const {onClose, onAccept, isOpen} = props
    const {t} = useTranslation()
    if (!isOpen) {
        return null
    }

    return (
        <Modal flexibleHeight className="-trial-to-plan" onClose={onClose}>
            <div className="w-full">
                <img src={designerPng} className="mx-auto block h-[200px] w-auto"/>
                <h2 className="text-2xl pb-3 text-center font-semibold">
                    {t('popup.trialToPlan.title')}
                </h2>
                <p className="pb-12 text-center text-gray-400"
                   dangerouslySetInnerHTML={{__html: t('popup.trialToPlan.description')}}
                />

                <Button className="block w-full" onClick={onAccept}>
                    {t('popup.trialToPlan.btn')}
                </Button>
            </div>
        </Modal>
    )
}


export default TrialToPlanModal
